module.exports = "/_next/static/images/22bb9132cf5e1650e1c223b99826aa90-card-and-phone-3d-lg@2x.jpg";